import { render } from "./SessionsbyRegion.vue?vue&type=template&id=e0921610&scoped=true"
import script from "./SessionsbyRegion.vue?vue&type=script&lang=js"
export * from "./SessionsbyRegion.vue?vue&type=script&lang=js"

import "./SessionsbyRegion.vue?vue&type=style&index=0&id=e0921610&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0921610"]])

export default __exports__